export var CreditAssessmentResult;
(function (CreditAssessmentResult) {
    CreditAssessmentResult["Approve"] = "approve";
    CreditAssessmentResult["Reject"] = "reject";
    CreditAssessmentResult["AssessManually"] = "assessManually";
})(CreditAssessmentResult || (CreditAssessmentResult = {}));
